import { Inject, Pipe, PipeTransform } from '@angular/core'
import { OrderByService } from '../services/order-by.service'

@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

    constructor(@Inject(OrderByService) private orderByService: OrderByService) {
    }

    transform(array: any[], field: string|string[], sortDir = 'asc'): any[] {
        let sortDesc = sortDir === 'desc'
        return array?.length ? this.orderByService.orderBy(array, Array.isArray(field) ? field : [field], sortDesc) : null
    }

}